<app-header></app-header>
<div class="auth-container flex flex-col lg:flex-row" style="margin-top: -30px;">

  <div *ngIf="isSubmitting" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg">
      <div class="flex items-center">
        <svg class="animate-spin h-5 w-5 mr-3 text-wattpad-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>Processing your request...</span>
      </div>
    </div>
  </div>
  
  <!-- Left Side (Branding) - Hidden on mobile -->
  <div class="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-wattpad-primary to-wattpad-secondary items-center justify-center p-12">
    <div class="max-w-md text-center text-white">
      <h1 class="text-4xl font-bold mb-6">Join Funtel</h1>
      <p class="text-lg mb-8">Write, Discover and share amazing stories with a community of millions.</p>
      <div class="flex justify-center space-x-4">
        <div class="bg-white/20 p-3 rounded-full">
          <i class="fas fa-pen-fancy text-xl"></i>
        </div>
        <div class="bg-white/20 p-3 rounded-full">
          <i class="fas fa-globe text-xl"></i>
        </div>
        <div class="bg-white/20 p-3 rounded-full">
          <i class="fas fa-trophy text-xl"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Side (Form) -->
  <div class="w-full lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
    <div class="w-full max-w-md">
      <div class="text-center lg:hidden mb-8"></div>

      <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 lg:p-8 relative">
        <h2 class="text-2xl font-bold mb-6">Sign Up</h2>
        
        <!-- Success Message -->
        <div *ngIf="message" class="mb-4 p-3 bg-green-100 text-green-700 rounded-lg">
          {{message}}
        </div>
        
        <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
          <div class="mb-4">
            <label for="first-name" class="block text-sm font-medium mb-2">First Name</label>
            <input type="text" id="first-name" formControlName="first_name"
              class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700"
              placeholder="First name">
            <span *ngIf="signupForm.get('first_name')?.touched && signupForm.get('first_name')?.errors?.['required']" 
                  class="text-red-500 text-xs">✖ First name is required</span>
          </div>

          <div class="mb-4">
            <label for="mobile" class="block text-sm font-medium mb-2">Mobile Number</label>
            <div class="flex">
              <input type="tel" id="mobile" formControlName="mobile"
                class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700"
                placeholder="Enter your 10-digit mobile number">
              <button type="button" (click)="sendOtp()" [disabled]="!signupForm.get('mobile')?.valid || isCheckingMobile || otpSent || mobileStatus === 'taken'"
                class="ml-2 px-4 py-3 bg-wattpad-primary text-white rounded-lg hover:bg-[#E5274B] disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap">
                {{otpSent ? (countdown + 's') : 'Send OTP'}}
              </button>
            </div>
            <div class="mt-1 text-xs">
              <span *ngIf="signupForm.get('mobile')?.touched && signupForm.get('mobile')?.errors?.['required']" class="text-red-500">✖ Mobile number is required</span>
              <span *ngIf="signupForm.get('mobile')?.touched && signupForm.get('mobile')?.errors?.['pattern']" class="text-red-500">✖ Please enter a valid 10-digit mobile number</span>
              <span *ngIf="mobileStatus === 'checking'" class="text-blue-500">Checking availability...</span>
              <span *ngIf="mobileStatus === 'available'" class="text-green-500">✔ Mobile number is available</span>
              <span *ngIf="mobileStatus === 'taken'" class="text-red-500">✖ Mobile number already registered</span>
            </div>
          </div>

          <div class="mb-4" *ngIf="showOtpField">
            <label for="otp" class="block text-sm font-medium mb-2">Verification Code</label>
            <input type="text" id="otp" formControlName="otp" maxlength="6"
              class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700"
              placeholder="Enter OTP sent to your mobile">
            <span *ngIf="signupForm.get('otp')?.touched && !signupForm.get('otp')?.value" 
                  class="text-red-500 text-xs">✖ OTP is required</span>
          </div>

          <div class="mb-6">
            <div class="flex items-start">
              <input type="checkbox" id="terms" formControlName="terms"
                class="mt-1 rounded border-gray-300 text-wattpad-primary focus:ring-wattpad-primary dark:border-gray-600 dark:bg-gray-700">
              <label for="terms" class="ml-2 text-sm text-gray-600 dark:text-gray-300">
                I agree to the <a href="#" class="text-wattpad-primary hover:underline">Terms</a> and <a href="#"
                  class="text-wattpad-primary hover:underline">Privacy Policy</a>
              </label>
            </div>
            <span *ngIf="signupForm.get('terms')?.touched && !signupForm.get('terms')?.value" 
                  class="text-red-500 text-xs">✖ You must accept the terms and conditions</span>
          </div>

          <button type="submit" [disabled]="isSubmitting"
            class="w-full bg-wattpad-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-[#E5274B] disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors mb-4">
            {{isSubmitting ? 'Creating Account...' : 'Create Account'}}
          </button>
          
          <div *ngIf="submissionErrors.length" class="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
            <ul class="list-disc pl-5">
              <li *ngFor="let err of submissionErrors">{{ err }}</li>
            </ul>
          </div>
          
          <div class="flex items-center justify-center mb-6">
            <div class="border-t border-gray-300 dark:border-gray-600 flex-grow"></div>
            <span class="px-3 text-sm text-gray-500">or</span>
            <div class="border-t border-gray-300 dark:border-gray-600 flex-grow"></div>
          </div>

          <div class="text-center text-sm">
            <span class="text-gray-600 dark:text-gray-300">Already have an account?</span>
            <a href="/login" class="text-wattpad-primary font-medium hover:underline ml-1">Log in</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Mobile Bottom Navigation -->
<nav class="bottom-nav fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden">
  <div class="flex justify-around items-center h-full">
    <a href="index4.html" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
      <i class="fas fa-home text-xl"></i>
      <span class="text-xs mt-1">Home</span>
    </a>
    <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
      <i class="fas fa-search text-xl"></i>
      <span class="text-xs mt-1">Search</span>
    </a>
    <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
      <i class="fas fa-bookmark text-xl"></i>
      <span class="text-xs mt-1">Library</span>
    </a>
    <a href="#" class="text-wattpad-primary flex flex-col items-center">
      <i class="fas fa-user text-xl"></i>
      <span class="text-xs mt-1">Profile</span>
    </a>
  </div>
</nav>